/* unplugin-vue-components disabled */import script from "./utility-hero.vue?vue&type=script&lang=js"
export * from "./utility-hero.vue?vue&type=script&lang=js"

import "./utility-hero.vue?vue&type=style&index=0&id=38d97f1f&lang=scss"

const __exports__ = script;

export default __exports__